export default {
  app: {
    golf: {
      title: 'Kentän tiedot',
      hasEVChargingPoint: 'Sähköauton latauspiste',
      hasCaddieService: 'Caddie-palvelu',
      hasTrolley: 'Kärry',
      hasBuggy: 'Buggy',
      hasClubRental: 'Mailavuokraus',
      hasAcademy: 'Akatemia',
      hasMarshal: 'Marshal',
      hasPGACertification: 'PGA-sertifioitu',
      hasTrainingArea: 'Harjoittelualue',
      hasRestaurant: 'Ravintola',
      hasHotel: 'Hotelli',
      hasDogsOnCourse: 'Koirat kentällä',
      numberOfHoles: 'Reikien määrä',
    },
  },
};
